import { useTheme, useMediaQuery } from "@mui/material";
const useBreakpoints = () => {
  const theme = useTheme(), xsOnly = useMediaQuery(theme.breakpoints.only("xs")), sm = useMediaQuery(theme.breakpoints.up("sm")), smOnly = useMediaQuery(theme.breakpoints.only("sm")), md = useMediaQuery(theme.breakpoints.up("md")), mdOnly = useMediaQuery(theme.breakpoints.only("md")), lg = useMediaQuery(theme.breakpoints.up("lg")), lgOnly = useMediaQuery(theme.breakpoints.only("lg")), xl = useMediaQuery(theme.breakpoints.up("xl")), xlOnly = useMediaQuery(theme.breakpoints.only("xl")), xxl = useMediaQuery(theme.breakpoints.up("xxl")), xxlOnly = useMediaQuery(theme.breakpoints.only("xxl"));
  return {
    xs: !0,
    xsOnly,
    sm,
    smOnly,
    md,
    mdOnly,
    lg,
    lgOnly,
    xl,
    xlOnly,
    xxl,
    xxlOnly
  };
};
export {
  useBreakpoints
};
//# sourceMappingURL=useBreakpoints.js.map
